import { queryOptions } from "@tanstack/react-query";

import { graphqlClient } from "@/api/graphql";
import { graphql } from "@/generated/digitalnisklady.cz";
import {
  mapCropParameter,
  sortCropParameter,
} from "@/routes/marketplace/mappings/crop-parameter";

// eslint-disable-next-line lingui/no-unlocalized-strings
const cropParametersQueryDocument = graphql(`
  query CropParameters($cropId: ID!, $traderId: ID) {
    crop(id: $cropId) {
      parameters(traderId: $traderId) {
        edges {
          node {
            id
            title
            ... on SelectCropParameter {
              __typename
              options {
                edges {
                  node {
                    cropParameter {
                      title
                    }
                  }
                }
              }
            }
            ... on TextCropParameter {
              __typename
              title
              required
              textDefault
              uri
            }
            ... on FloatCropParameter {
              __typename
              title
              min
              max
              uri
              unit
            }
          }
        }
      }
    }
  }
`);

const cropParametersQuery = (variables: {
  cropId: string;
  traderId?: string;
}) =>
  queryOptions({
    queryFn: () =>
      graphqlClient.request(cropParametersQueryDocument, variables),
    queryKey: ["crop-parameters", variables],
    select: (data) =>
      data.crop?.parameters?.edges
        ?.map(mapCropParameter)
        .toSorted(sortCropParameter)
        .map((p) => ({
          label: p.at(0),
          value: p.at(1),
        })),
  });

export { cropParametersQuery };
